import {FunctionComponent, useContext, useEffect, useRef, useState} from 'react';
import MapContext from '../map/MapContext';
import {Vector as VectorSource} from 'ol/source';
import Cluster from 'ol/source/Cluster';
import VectorLayer from 'ol/layer/Vector';
import {useTranslation} from 'react-i18next';
import {useAppSelector} from '../../../redux/hooks';
import {createPoiPoint, setPermaLayerVisible} from '../../../functions/functionsOpenlayer';
import geoSettings from '../../../config/geoSettings';
import {Circle, Fill, Icon, Stroke, Style} from 'ol/style';
import {Feature} from 'ol';
import {Point} from 'ol/geom';
import {usePrevious} from 'primereact/hooks';

type poiProps = {
    pois: any,
    zoomTo: any
}

const PoiLayer: FunctionComponent<poiProps> = ({pois, zoomTo}) => {
    //  console.log(pois)
    // @ts-ignore
    const {map, setMap} = useContext(MapContext);
    const {t} = useTranslation(['geomonitoring']);
    const permaLinkArray = useAppSelector((state: any) => state.configLayer.layerData.permaLinkLayer);
    const isPermaLink = useAppSelector((state: any) => state.configLayer.layerData.isPermaLink);
    const [vLayer, setVlayer] = useState(null);
    const [mpArray, setMpArray] = useState([]);

    const [nSource, setNSource] = useState({
        removeFeature(feature: any) {

        },
        addFeature(mp: any) {

        },
        addFeatures(features: any[]) {

        },
        clear() {

        }
    });
    const refVLayer = useRef(vLayer);
    const refNSource = useRef(nSource);
    const refMpArray = useRef(mpArray);

    const scaleImage = {
        18: 0.05,
        19: 0.08,
        20: 0.12,
        default: 0.14
    };

    const getImageFileString = (imageData: any) => {
        const imageKind = getImageType(imageData.adresse_type_id);
        const postLadeType = getPostOrLadeAddress(imageData.ladungsadresse, imageData.postadresse);
        //  console.log(imageKind, postLadeType, imageData)
        return imageKind + postLadeType;
    };

    const getPostOrLadeAddress = (ladeaddress: boolean, postaddress: boolean) => {
        let string = '';
        switch (true) {
            case (ladeaddress && !postaddress):
                string = '_lade';
                break;
            case (ladeaddress && postaddress):
                string = '_postLade';
                break;
            case (postaddress && !ladeaddress):
                string = '_post';
                break;
        }
        return string;
    };
    const getImageType = (typeId: any) => {
        let imageName;
        if (typeof typeId==='object' ) {
            typeId=typeId.adresse_type_id;
        }
        switch (typeId) {
            case 1:
                imageName = 'wohnsitz';
                break;
            case 2:
                imageName = 'postfach';
                break;
            case 3:
                imageName = 'zweitwohnsitz';
                break;
            case 4:
                imageName = 'feriendomizil';
                break;
            case 5:
                imageName = 'arbeit';
                break;
            case 6:
                imageName = 'hauptsitz';
                break;
            case 7:
                imageName = 'niederlassung';
                break;
            case 8:
                imageName = 'betriebsstaette';
                break;
            case 9:
                imageName = 'direktion';
                break;
            case 10:
                imageName = 'aussenstelle';
                break;
            case 11:
                imageName = 'amt';
                break;
            case 12:
                imageName = 'postfach';
                break;
            default:
                imageName = 'unbekannt';
        }

        return imageName;
    };
    const getFeatureImage = (feature: { get: any }) => {
        const featureInfoIcon = feature.get('icon');
        const fIcon = getImageFileString(featureInfoIcon);
        // if(fIcon==null&&fIcon==undefined)console.log(fIcon)
        const icon = fIcon !== null && fIcon !== undefined ? fIcon : 'unbekannt';
        const url = geoSettings.livingTypeImageUrl + '/' + icon + '.png';
        return url;
    };

    const getMpStyles = (feature: any, resolution: any) => {
        const zoom = Math.round(map.getView().getZoom());
        const zoomIndex = zoom as keyof typeof scaleImage;
        const iconStyle = new Icon(({
            scale: (scaleImage[zoomIndex] ? scaleImage[zoomIndex] : scaleImage.default) / 0.275,
            src: getFeatureImage(feature)
        }));

        const style = new Style({
            image: iconStyle,
            stroke: new Stroke({
                color: '#000000',
                width: 5 / 4
            })
        });
        // console.log(style)
        return style;
    };

    const getVectorLayerObject = (source: any, layerId: string, layerVisibility: boolean) => {

        const vectorLayer = new VectorLayer({
            source: source
        });

        vectorLayer.set('name', layerId);
        vectorLayer.set('id', layerId);
        vectorLayer.set('type', 'vector');
        vectorLayer.set('zIndex', geoSettings.poiLayerKey);
        vectorLayer.set('visible', layerVisibility);
        vectorLayer.setStyle(getMpStyles);
        return vectorLayer;
    };

    const createFeatures = async (data: any[]) => {
        const featureArray: any[] = [];
        for (const v of Object.keys(data)) {
            const elem = data[parseInt(v)];
            const point = await createPoiPoint(elem);
            featureArray.push(point);
        }
        return {features: featureArray};
    };

    const createLayer = async (map: any) => {
        const layerId = 'poiLayer';
        const layerVisibility = setPermaLayerVisible(true, isPermaLink, permaLinkArray, layerId);
        const source = new VectorSource({});
        setNSource(source);
        refNSource.current = source;
        const vectorLayer = getVectorLayerObject(source, layerId, layerVisibility);

        map.addLayer(vectorLayer);
        // @ts-ignore
        setVlayer(vectorLayer);
        setMap(map);

        return () => {
            if (map) {
                map.removeLayer(vectorLayer);
            }
        };
    };

    const zoomToFeature=(zoom:number)=>{
        const layers = map.getLayers().getArray();
        layers.forEach((layer: any) => {
            if (layer.get('id') === 'poiLayer' && zoom !== null) {
                const features = layer.getSource().getFeatures();
                features.forEach((f: any) => {
                    if (f.get('id') === 'addressPosition_' + zoom) {
                        const coordinates = f.getGeometry().getCoordinates();
                        map.getView().setCenter(coordinates);
                    }
                });
            }
        });
    };

    useEffect(() => {
        refVLayer.current = vLayer;
        refNSource.current = nSource;
    }, [vLayer]);


    useEffect(() => {
        refMpArray.current = mpArray;
    }, [mpArray]);

    useEffect(() => {
        nSource.clear();
        refNSource.current.clear();
        if (!map || Object.keys(map).length === 0) return;

        if (pois.data && Object.keys(pois.data).length > 0) {
            createFeatures(pois.data).then(f => {
                nSource.addFeatures(f.features);
                refNSource.current.addFeatures(f.features);
                if (zoomTo===null) return;
                map.getView().setCenter(f.features[parseInt(pois.index)].getGeometry().getCoordinates());
                map.getView().setZoom(17);


            });
        }

    }, [pois, map]);


    useEffect(() => {
        if (!map || Object.keys(map).length === 0) return;

        // eslint-disable-next-line no-console
        createLayer(map).then(r => console.log('PoiLayer erstellt'));

    }, [map]);


    useEffect(() => {
        if (!map || Object.keys(map).length === 0) return;

        zoomToFeature(zoomTo);
    }, [zoomTo]);


    return null;
};

export default PoiLayer;
